export default {
    data: () => ({
        alert: {
            show: false,
            type: "success",
            texto: "Registro salvo com sucesso",
            dismissible: false,
        }
    }),
    methods: {
        resetAlert() {
            this.alert = { show: false, type: "success", texto: "", dismissible: false };
        },
        setAlert(tipo, msg) {
            this.alert = { show: true, type: tipo, texto: msg, dismissible: false };
        },
    }
};
